export function GridCardHome({ children }: { children: React.ReactNode }) {
	return (
		<div className="pt-2 grid grid-cols-2 sm:grid-cols-2 gap-4 md:gap-6 lg:gap-8">
			{children}
		</div>
	);
}
